module.exports = __webpack_public_path__ + "static/date-range-bf6da3e6a100a6f591a0f1414ff256b1.png";